import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./Section5.css";

// 🔥 Firebase
import { db } from "./firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

const Section5 = () => {
  const [formData, setFormData] = useState({
    subscriber_name: "",
    to_email: ""
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(""); 
  // "success" | "partial" | "error"

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);
    setStatus("");

    console.log("📤 Sending EmailJS data:", formData);

    try {
      // ✅ 1. Send EmailJS
      const res = await emailjs.send(
        "service_5cbrmqq",
        "template_7w4k8uf",
        {
          subscriber_name: formData.subscriber_name,
          to_email: formData.to_email,
        },
        "gZAVxGd1AtQzI_U9z"
      );

      console.log("✅ Email sent:", res.status, res.text);

      // ✅ 2. Save to Firebase
      try {
        await setDoc(doc(db, "subscribers", formData.to_email), {
          name: formData.subscriber_name,
          email: formData.to_email,
          createdAt: serverTimestamp()
        });

        console.log("🔥 Saved to Firebase");

        setStatus("success");

      } catch (firebaseError) {
        console.error("🔥 Firebase error:", firebaseError);

        // Email worked but DB failed
        setStatus("partial");
      }

      setFormData({
        subscriber_name: "",
        to_email: ""
      });

    } catch (err) {
      console.error("❌ Email failed:", err);

      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="section5" id="section5">
      <div className="section5-inner">

        <div className="section-title">
          <span className="expertise-text">Our Expertise</span>
          <div className="line"></div>
        </div>

        <div className="services-container">
          <div className="services-left">
            <h2>Services</h2>
            <p>
              Comprehensive services designed to bring your vision to life with innovation and care.
            </p>
          </div>

          <div className="services-right">
            <div className="service">
              <h4>Architecture</h4>
              <p>Designing innovative and sustainable buildings that stand the test of time.</p>
            </div>

            <div className="service">
              <h4>Consultancy</h4>
              <p>Providing expert advice to navigate complex challenges and achieve success.</p>
            </div>

            <div className="service">
              <h4>Urban Planning</h4>
              <p>Creating well-planned, sustainable communities for the future.</p>
            </div>

            <div className="service">
              <h4>Project Management</h4>
              <p>Ensuring smooth project execution with precision and efficiency.</p>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <h2>Get in Touch</h2>

          <p>
            Visit our Contact Page for more information on how to reach our offices and departments.
          </p>

          <form className="contact-form" onSubmit={sendEmail}>
            <input
              type="text"
              name="subscriber_name"
              placeholder="Your Name"
              value={formData.subscriber_name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="to_email"
              placeholder="Your Email"
              value={formData.to_email}
              onChange={handleChange}
              required
            />

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Submit"}
            </button>
          </form>

          {/* STATUS MESSAGES */}

          {status === "success" && (
            <p style={{ color: "lightgreen", marginTop: "10px" }}>
              ✅ Email sent & saved successfully 
            </p>
          )}

          {status === "partial" && (
            <p style={{ color: "orange", marginTop: "10px" }}>
              ⚠️ Email sent but NOT saved to database
            </p>
          )}

          {status === "error" && (
            <p style={{ color: "tomato", marginTop: "10px" }}>
              ❌ Failed to send message. Double check the email
            </p>
          )}
        </div>

        <div className="centered-image">
          <img src="/Basemap-image.png" alt="Contact" />
        </div>

      </div>
    </div>
  );
};

export default Section5;